'use client'

import React from 'react'

import { css } from '@news/styled-system/css'

const buttonStyles = css({
    position: 'sticky',
    top: '[calc(100vh - 52px)]',
    zIndex: 20,

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    width: '[40px]',
    height: '[40px]',
    borderRadius: 'round',

    backgroundColor: 'info',
    color: 'white',
    fontSize: '[1.25rem]',

    transition: '[opacity 0.3s ease-in-out]',

    border: '[1px solid white]',
    boxShadow: '[0 0 8px 2px rgba(255, 255, 255, 0.6)]',
})

export function ScrollTopButton() {
    const isVisible = useButtonVisibility()
    const handleClick = () => window.scrollTo({ top: 0, behavior: 'smooth' })

    return (
        <button className={buttonStyles} style={{ opacity: isVisible ? 0.75 : 0 }} onClick={handleClick}>
            <i className="fas fa-arrow-up" />
        </button>
    )
}

const containerStyles = css({
    position: 'absolute',
    height: 'full',
    right: '2',
})

export function ScrollTopButtonContainer({ children }: { children: React.ReactNode }) {
    return <div className={containerStyles}>{children}</div>
}

function useButtonVisibility(): boolean {
    return React.useSyncExternalStore(
        (callback) => {
            window.addEventListener('scroll', callback)
            return () => window.removeEventListener('scroll', callback)
        },
        () => window.scrollY > 800,
        () => false // Server snapshot
    )
}
